import { GraphQLError, print, parse, validate as validateDocument, } from 'graphql';
import { DepGraph } from 'dependency-graph';
import { readDocument } from '../ast/document';
import { findDeprecatedUsages } from '../utils/graphql';
import { validateQueryDepth } from './query-depth';
import { transformSchemaWithApollo, transformDocumentWithApollo, } from '../utils/apollo';
export function validate(schema, sources, options) {
    const config = Object.assign({ strictDeprecated: true, strictFragments: true, keepClientFields: false, apollo: false }, options);
    const invalidDocuments = [];
    // read documents
    const documents = sources.map(readDocument);
    // keep all named fragments
    const fragments = [];
    const fragmentNames = [];
    const graph = new DepGraph({ circular: true });
    documents.forEach((doc) => {
        doc.fragments.forEach((fragment) => {
            fragmentNames.push(fragment.node.name.value);
            fragments.push(fragment);
            graph.addNode(fragment.node.name.value, fragment.node);
        });
    });
    fragments.forEach((fragment) => {
        const depends = extractFragments(print(fragment.node));
        if (depends) {
            depends.forEach((name) => {
                graph.addDependency(fragment.node.name.value, name);
            });
        }
    });
    documents
        // since we include fragments, validate only operations
        .filter((doc) => doc.hasOperations)
        .forEach((doc) => {
        const docWithOperations = {
            kind: 'Document',
            definitions: doc.operations.map((d) => d.node),
        };
        const extractedFragments = (extractFragments(print(docWithOperations)) || [])
            // resolve all nested fragments
            .map((fragmentName) => resolveFragment(graph.getNodeData(fragmentName), graph))
            // flatten arrays
            .reduce((list, current) => list.concat(current), [])
            // remove duplicates
            .filter((def, i, all) => all.findIndex((item) => item.name.value === def.name.value) === i);
        const merged = {
            kind: 'Document',
            definitions: [...docWithOperations.definitions, ...extractedFragments],
        };
        const transformedSchema = config.apollo
            ? transformSchemaWithApollo(schema)
            : schema;
        const transformedDoc = config.apollo
            ? transformDocumentWithApollo(merged, {
                keepClientFields: config.keepClientFields,
            })
            : merged;
        const errors = validateDocument(transformedSchema, transformedDoc) || [];
        if (config.maxDepth) {
            const depthError = validateQueryDepth({
                source: doc.source,
                doc: transformedDoc,
                maxDepth: config.maxDepth,
                fragmentGraph: graph,
            });
            if (depthError) {
                errors.push(depthError);
            }
        }
        const deprecated = config.strictDeprecated
            ? findDeprecatedUsages(transformedSchema, parse(doc.source.body))
            : [];
        const duplicatedFragments = config.strictFragments
            ? findDuplicatedFragments(fragmentNames)
            : [];
        if (sumLengths(errors, duplicatedFragments, deprecated) > 0) {
            invalidDocuments.push({
                source: doc.source,
                errors: [...errors, ...duplicatedFragments],
                deprecated,
            });
        }
    });
    return invalidDocuments;
}
function findDuplicatedFragments(fragmentNames) {
    return fragmentNames
        .filter((name, i, all) => all.indexOf(name) !== i)
        .map((name) => new GraphQLError(`Name of '${name}' fragment is not unique`));
}
//
// PostInfo -> AuthorInfo
// AuthorInfo -> None
//
function resolveFragment(fragment, graph) {
    return graph
        .dependenciesOf(fragment.name.value)
        .reduce((list, current) => [
        ...list,
        ...resolveFragment(graph.getNodeData(current), graph),
    ], [fragment]);
}
function extractFragments(document) {
    return (document.match(/[\.]{3}[a-z0-9\_]+\b/gi) || []).map((name) => name.replace('...', ''));
}
function sumLengths(...arrays) {
    return arrays.reduce((sum, { length }) => sum + length, 0);
}
//# sourceMappingURL=index.js.map